// removed by extract-text-webpack-plugin
module.exports = {"form-warning":"form-warning","conversation-input-file-wrap":"conversation-input-file-wrap","user-form-wrap":"user-form-wrap","inputfile":"inputfile","conversation-content-wrap":"conversation-content-wrap","box-header":"box-header","conversation-content":"conversation-content","btn-post-conversation":"btn-post-conversation"};


//////////////////
// WEBPACK FOOTER
// ./components/conversations/_form.scss
// module id = ./components/conversations/_form.scss
// module chunks = 0